// extracted by mini-css-extract-plugin
export var cls1 = "dermapen-module--cls1--2mBmz";
export var svgElem1 = "dermapen-module--svgElem1--3k9QA";
export var active = "dermapen-module--active--SQcmW";